import cn from 'classnames';
import { Icon } from 'ht-styleguide';
import PhoneDisplayLink, { ICON_ORIENTATION } from '@components/PhoneDisplayLink';
import styles from './phonefooter.module.scss';

/* Types */
type PhoneFooterProps = {
  className?: string;
};

const PhoneIcon = () => <Icon name="phone-outlined" className={styles.phoneIcon} />;

const PhoneFooter = ({ className }: PhoneFooterProps) => {
  const phoneFooterStyles = cn(className, styles.phoneFooter);
  const linkStyles = cn('-no-decoration', styles.phoneDisplay);
  return (
    <div className={phoneFooterStyles}>
      <p className="p0 n700">
        <PhoneDisplayLink displayNumber icon={<PhoneIcon />} linkStyle={linkStyles} iconOrientation={ICON_ORIENTATION.left} />
      </p>
    </div>
  );
};

export default PhoneFooter;
